import React from 'react';
import { useFetchWithCache } from '../hooks/useFetchWithCache';
import LoadingSpinner from '../components/LoadingSpinner';
import { PageBanner, BannerContent } from './styles/Shared.styles';
import {
  SectionBlock, Inner, GridRow, SectionTitle, SectionEyebrow, Body, ItemList, ImageBlock,
} from './styles/About.styles';

const About = () => {
  const { data: about, loading } = useFetchWithCache('/about');

  if (loading && !about) return <LoadingSpinner fullPage />;
  const a = about || {};
  const sections = Array.isArray(a.sections) ? a.sections : [];

  return (
    <>
      <PageBanner $src={a.bannerImage}>
        <BannerContent>
          <span className="eyebrow">About Us</span>
          <h1>{a.title || 'About Ehcerex'}</h1>
          {a.description && <p>{a.description}</p>}
        </BannerContent>
      </PageBanner>

      {sections.map((section, idx) => {
        const dark = idx % 3 === 2;
        const alt = idx % 2 === 1 && !dark;
        const hasImage = Array.isArray(section.images) && section.images[0];
        const reverse = idx % 2 === 1;
        return (
          <SectionBlock key={section.key || idx} $dark={dark} $alt={alt}>
            <Inner>
              <GridRow $hasImage={!!hasImage} style={{ direction: reverse && hasImage ? 'rtl' : 'ltr' }}>
                <div style={{ direction: 'ltr' }}>
                  <SectionEyebrow $dark={dark}>Section {String(idx + 1).padStart(2, '0')}</SectionEyebrow>
                  <SectionTitle $dark={dark}>
                    {section.title || section.key}
                  </SectionTitle>
                  <Body $dark={dark}>
                    {section.description && section.description.split('\n').map((p, i) => (
                      <p key={i}>{p}</p>
                    ))}
                  </Body>
                  {Array.isArray(section.items) && section.items.length > 0 && (
                    <ItemList $dark={dark}>
                      {section.items.map((item, i) => (
                        <li key={i}>
                          <span className="num">{String(i + 1).padStart(2, '0')}</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ItemList>
                  )}
                </div>
                {hasImage && (
                  <div style={{ direction: 'ltr' }}>
                    <ImageBlock>
                      <img src={section.images[0]} alt={section.title || ''} />
                    </ImageBlock>
                  </div>
                )}
              </GridRow>
            </Inner>
          </SectionBlock>
        );
      })}

      {sections.length === 0 && (
        <SectionBlock>
          <Inner>
            <Body>
              <p>No about content has been added yet.</p>
            </Body>
          </Inner>
        </SectionBlock>
      )}
    </>
  );
};

export default About;
